import React from 'react';
import { Button, ButtonProps } from '@mui/material';
import { COLORS } from '../../Constants/styles';

interface AccentButtonProps extends ButtonProps {
  label: string;
  href: string;
  download?: string;
  target?: string;
  rel?: string;
}

const AccentButton: React.FC<AccentButtonProps> = ({ label, href, ...props }) => {
  return (
    <Button
      variant="contained"
      href={href}
      sx={{
        bgcolor: COLORS.accentLime,
        color: COLORS.accentDarkGreen,
        border: `1px solid ${COLORS.accentDarkGreen}`,
        fontWeight: 600,
        fontFamily: "'Big Shoulders Text', sans-serif",
        textDecoration: 'none',
        textTransform: 'uppercase',
        '&:hover': {
          bgcolor: COLORS.accentDarkGreen,
          color: COLORS.accentLime,
          border: `1px solid ${COLORS.accentLime}`,
        },
      }}
      {...props}
    >
      {label}
    </Button>
  );
};

export default AccentButton;
